<template>
  <HomeDetailInfoSiteOne>
    <template #header-one>
      <div style="display: flex; flex-direction: row; padding: 30px 20px 30px 20px;">
        <h1 style="width: 50%"> We ... </h1>
        <h1 style="width: 50%"> Because ... </h1>
      </div>
    </template>
    <template #text-one>
      <div style="display: flex; flex-direction: row; width: 100%; gap: 10px">
        <div style="display: flex; flex-direction: column; align-items: center; width: 50%">
          <div class="power-of-takt-text-one">
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> PAY PEOPLE ON SITE EVERY WEEK - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;PER WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> TENDER WORK - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;PER WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> STANDARDIZE WORK - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;PER WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> SCALE DATA - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;PER WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row; ">
              <p style="text-align: right;"> AUTOMATE FLOW - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;PER WORKPACKAGE </p>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; align-items: center; width: 50%">
          <div class="power-of-takt-text-one">
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> NO PROBLEM IS BIGGER THAN - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;A WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> NOTHING IS MORE COMPLEX THAN - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;A WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> EVERYBODY CAN VERIFY CONTENT OF - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;A WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row">
              <p style="text-align: right;"> DATA IS ALWAYS REFERED TO - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;A WORKPACKAGE </p>
            </div>
            <div style="display: flex; flex-direction: row; ">
              <p style="text-align: right;"> ALL SOLUTIONS ARE DEVELOPED FOR - </p>
              <p style="color: #00fdff; white-space: pre"> &nbsp;A WORKPACKAGE </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #image>
      <img width="90%" src="@/assets/PowerOfTakt-TheWorkpackage.png">
    </template>
  </HomeDetailInfoSiteOne>
</template>

<script>
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'

export default {
  components: {
    HomeDetailInfoSiteOne
  }
}
</script>

<style>
.power-of-takt-one {
  display: flex;
  flex-direction: column;
  padding: 100px;
  font-style: italic;
  /* background-color: red; */
  /* height: 100%; */
}
.power-of-takt-text-one {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  /* text-align: left; */
  /* padding-left: 20%; */
  width: 100%;
  align-items: flex-end;
}
</style>
